import { combineReducers } from 'redux';

import joinedPrograms from './joinedPrograms';
import invitations from './invitations';
import acceptConsent from './acceptConsent';
import declineInvitation from './declineInvitation';
import acceptInvitation from './acceptInvitation';
import leaveProgram from './leaveProgram';
import availablePrograms from './availablePrograms';
import assignPrograms from './assignPrograms';
import accountVaults from './accountVaults';
import paymentInfoModal from './payment-info-modal';
import accountVaultsForm from './accountVaultsForm';
import submitPaymentProgram from './submitPaymentProgram';

export default combineReducers({
  joinedPrograms,
  invitations,
  acceptConsent,
  acceptInvitation,
  declineInvitation,
  leaveProgram,
  availablePrograms,
  assignPrograms,
  accountVaults,
  accountVaultsForm,
  paymentInfoModal,
  submitPaymentProgram,
});



// WEBPACK FOOTER //
// ./src/redux/programs/index.js